import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled/macro'

import { FormGroup, RadioGroup } from '@mui/material'

const ImageUploadLabel = styled.label`
  display: flex;
  align-items: center;
`

const ImageUploadText = styled.span`
  padding-left: ${size(2)};
  font-size: ${fontSize('lg')};
  font-weight: bold;
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
`

const SectionHeading = styled.h2`
 margin: 0 0 0 ${size(1)};
 padding: 0 0 ${size(1)} 0;
`

const DialogFormGroup = styled(FormGroup)`
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const DialogRadioGroup = styled(RadioGroup)`
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export { ImageUploadLabel, ImageUploadText, Section, SectionHeading, DialogFormGroup, DialogRadioGroup }